import {ModbusRegister} from '@models/adminstration/gateway/gateway-configuration/modbus-register';

export class ModbusSlave {
  deviceId: number = 0;
  name: string = '';
  readCode: number = 0;
  registers: ModbusRegister[] = [];
}